import React from "react";

export default function DisabledFiltersStrip({ disabled }) {
  if (!disabled || disabled.length === 0) return null;
  const labels = disabled.map((d) => {
    if (d === "min_discount_pct")
      return "Minimum discount % (market comparison engine not yet enabled)";
    if (d === "yield_min")
      return "Minimum yield % (market comparison engine not yet enabled)";
    return d;
  });
  return (
    <div
      data-testid="disabled-filters-strip"
      className="border border-amber-500/40 bg-amber-500/10 text-amber-100 px-4 py-3 rounded-lg text-sm flex items-start gap-3"
    >
      <span className="text-amber-400">⚠</span>
      <div>
        Some of your filters are not yet active. They are saved and will turn
        on later:
        <ul className="list-disc ml-5 mt-1 text-amber-100/90">
          {labels.map((l) => (
            <li key={l}>{l}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
